import { isInsideFeedArea } from "./isInsideFeedArea";
import type { GovernedByFeedAreas } from "./types";

export const governedByFeedAreas: GovernedByFeedAreas = ({
  devicesByCircuit,
  systemByCircuit = {},
  categoryByCircuit = {},
  feedsCategory,
  areas,
  isSourceLive,
}) => {
  const governed: Record<string, string> = {};

  // In order, so a later area overwrites an earlier one where they overlap.
  areas.forEach((area) => {
    if (!isSourceLive(area.sourceLabel)) return;
    Object.entries(devicesByCircuit).forEach(([circuitId, devices]) => {
      // An emptied run would otherwise be "all inside" on a vacuous truth.
      if (devices.length === 0) return;
      // A zone takes only what its board feeds: a SIBE zone takes the emergency lights, nothing else.
      const category = categoryByCircuit[circuitId];
      if (category && feedsCategory) {
        if (!feedsCategory(area.sourceLabel, category)) return;
      } else if ((systemByCircuit[circuitId] ?? "power") !== "power") return;
      // Whole runs only until the circuit step can split a run at the zone edge.
      if (!devices.every((point) => isInsideFeedArea({ point, area }))) return;
      governed[circuitId] = area.sourceLabel;
    });
  });

  return governed;
};
